// src/routes/usersRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Users from '../pages/users/Users';
import CreateUsers from '../pages/users/CreateUsers';
import EditUsers from '../pages/users/EditUsers';
import ProtectedRoute from '../components/global/ProtectedRoute';

const usersRoutes = (
    <>
        {/* Users List */}
        <Route
            path="/users"
            element={
                <ProtectedRoute requiredPermission="users_list">
                    <Users />
                </ProtectedRoute>
            }
        />

        {/* Users Archive */}
        <Route
            path="/users/archive"
            element={
                <ProtectedRoute requiredPermission="users_archive_list">
                    <Users />
                </ProtectedRoute>
            }
        />

        {/* Create User */}
        <Route
            path="/users/create"
            element={
                <ProtectedRoute requiredPermission="users_create">
                    <CreateUsers />
                </ProtectedRoute>
            }
        />

        {/* Edit User */}
        <Route
            path="/users/:id/edit"
            element={
                <ProtectedRoute requiredPermission="users_edit">
                    <EditUsers />
                </ProtectedRoute>
            }
        />
    </>
);

export default usersRoutes;